import { render } from "./QDatePicker.vue?vue&type=template&id=b85a31f0&scoped=true"
import script from "./QDatePicker.vue?vue&type=script&lang=ts"
export * from "./QDatePicker.vue?vue&type=script&lang=ts"

import "./QDatePicker.vue?vue&type=style&index=0&id=b85a31f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b85a31f0"

export default script
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField});
